module.exports = __webpack_public_path__ + "img/SER-i-1-V.87087d05.png";